"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerView = void 0;
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const react_i18next_1 = require("react-i18next");
const Datepicker_1 = require("@amzn/atoz-web/Datepicker");
const SpinnerOverlay_1 = require("../SpinnerOverlay");
const DateManagement_1 = require("../../utils/DateManagement");
const hooks_1 = require("../../hooks");
const DatePickerView = ({ selectedDate, updateDateAction, daysWithAttention = [], daysWithShifts = [], daysWithPayDays = [], daysWithPunches = [], isLoading = false, locale = 'en-US', minDate, maxDate }) => {
    const defaultSearchParams = (0, hooks_1.useSearchParams)();
    const [searchParams, setSearchParams] = (0, react_1.useState)(defaultSearchParams);
    const { t } = (0, react_i18next_1.useTranslation)();
    const jsDatesWithShifts = daysWithShifts === null || daysWithShifts === void 0 ? void 0 : daysWithShifts.map(DateManagement_1.getLocalJSDate);
    const jsDatesWithPayDays = daysWithPayDays === null || daysWithPayDays === void 0 ? void 0 : daysWithPayDays.map(DateManagement_1.getLocalJSDate);
    const jsDatesWithPunches = daysWithPunches === null || daysWithPunches === void 0 ? void 0 : daysWithPunches.map(DateManagement_1.getLocalJSDate);
    const jsDatesWithAttention = daysWithAttention === null || daysWithAttention === void 0 ? void 0 : daysWithAttention.map(DateManagement_1.getLocalJSDate);
    const onChangeAction = (newDate) => {
        const newDateTime = (0, DateManagement_1.createDTDayInDefaultTZ)(newDate);
        (newDateTime === null || newDateTime === void 0 ? void 0 : newDateTime.isValid) &&
            setSearchParams(Object.assign(Object.assign({}, Object.entries(searchParams)), { date: newDateTime.toISODate() }));
        updateDateAction(newDateTime);
    };
    const markers = {
        primary: daysWithPunches && {
            label: t('time_and_attendance_DatePicker_punch_legend'),
            dates: jsDatesWithPunches
        },
        secondary: daysWithShifts && {
            label: t('time_and_attendance_DatePicker_shift_legend'),
            dates: jsDatesWithShifts
        },
        tertiary: daysWithPayDays && {
            label: t('time_and_attendance_DatePicker_payday_legend'),
            dates: jsDatesWithPayDays
        },
        attention: daysWithAttention && {
            label: t('time_and_attendance_DatePicker_attention_legend'),
            dates: jsDatesWithAttention
        }
    };
    const filterDate = (date) => {
        const currDate = luxon_1.DateTime.fromISO(date.toISOString());
        let isDateEnabled = true;
        if (minDate) {
            isDateEnabled = isDateEnabled && currDate >= minDate;
        }
        if (maxDate) {
            isDateEnabled = isDateEnabled && currDate <= maxDate;
        }
        return isDateEnabled;
    };
    return (react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isLoading },
        react_1.default.createElement(Datepicker_1.HamiltonDatepicker, { dataTestId: "DatePicker", selected: (0, DateManagement_1.getLocalJSDate)(selectedDate), inline: true, locale: locale, showDisabledMonthNavigation: true, formatWeekDay: (day) => day.substring(0, 3).toLocaleUpperCase(), onChange: onChangeAction, onMonthChange: onChangeAction, headerTextProps: {
                fontSize: 'T400',
                role: 'heading',
                'aria-level': 3
            }, overrideTodayDate: (0, DateManagement_1.getLocalJSDate)(luxon_1.DateTime.now()), markers: markers, previousMonthAriaLabel: t('time_and_attendance_DatePicker_prevButton'), nextMonthAriaLabel: t('time_and_attendance_DatePicker_nextButton'), filterDate: filterDate })));
};
exports.DatePickerView = DatePickerView;
